import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53ac9f87")

_pushScopeId("data-v-53ac9f87")
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_assign_product_group",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_6 = { class: "modal-body pt-10 pb-5 px-lg-17" }
const _hoisted_7 = { class: "scroll-y me-n7 pe-7" }
const _hoisted_8 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_9 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_10 = { class: "product-multi-select" }
const _hoisted_11 = { class: "product-multi-select__toolbar" }
const _hoisted_12 = { class: "product-multi-select__count" }
const _hoisted_13 = { class: "product-multi-select__list" }
const _hoisted_14 = {
  key: 0,
  class: "product-multi-select__empty"
}
const _hoisted_15 = { class: "mt-5" }
const _hoisted_16 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_17 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_18 = { class: "product-multi-select" }
const _hoisted_19 = { class: "product-multi-select__toolbar" }
const _hoisted_20 = { class: "product-multi-select__count" }
const _hoisted_21 = { class: "product-multi-select__list" }
const _hoisted_22 = {
  key: 0,
  class: "product-multi-select__empty"
}
const _hoisted_23 = { class: "modal-footer flex-center" }
const _hoisted_24 = {
  type: "reset",
  class: "btn btn-white me-3",
  "data-bs-dismiss": "modal"
}
const _hoisted_25 = { class: "indicator-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          model: _ctx.editProductGroupData,
          ref: "editProductGroupForm"
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_4, [
              _createVNode("h2", null, _toDisplayString(`${_ctx.$t('message.ASSIGN')} ${_ctx.$t('message.PRODUCTS')} & ${_ctx.$t('message.CATEGORIES')}`), 1),
              _hoisted_5
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("label", _hoisted_9, [
                    _createVNode("span", null, _toDisplayString(_ctx.$t('message.RELATED_PRODUCTS')), 1)
                  ]),
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.productSearch,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.productSearch = $event)),
                    clearable: "",
                    class: "mb-3",
                    placeholder: _ctx.$t('message.ENTER_KEY_TO_SEARCH')
                  }, null, 8, ["modelValue", "placeholder"]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.selectAllFiltered,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectAllFiltered = $event)),
                        indeterminate: _ctx.isFilteredIndeterminate,
                        disabled: _ctx.filteredProducts.length === 0
                      }, {
                        default: _withId(() => [
                          _createTextVNode(" Select all (" + _toDisplayString(_ctx.filteredProducts.length) + ") ", 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "indeterminate", "disabled"]),
                      _createVNode("span", _hoisted_12, _toDisplayString(_ctx.assignedProducts.length) + " selected ", 1)
                    ]),
                    _createVNode("div", _hoisted_13, [
                      _createVNode(_component_el_checkbox_group, {
                        modelValue: _ctx.assignedProducts,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.assignedProducts = $event))
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredProducts, (item) => {
                            return (_openBlock(), _createBlock(_component_el_checkbox, {
                              key: item.value,
                              class: "product-multi-select__item",
                              label: item.value
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(item.label), 1)
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_ctx.filteredProducts.length === 0)
                        ? (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(_ctx.$t('message.NO_DATA_FOUND')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_15, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("label", _hoisted_17, [
                      _createVNode("span", null, _toDisplayString(_ctx.$t('message.CATEGORIES')), 1)
                    ]),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.categorySearch,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.categorySearch = $event)),
                      clearable: "",
                      class: "mb-3",
                      placeholder: _ctx.$t('message.ENTER_KEY_TO_SEARCH')
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, [
                        _createVNode(_component_el_checkbox, {
                          modelValue: _ctx.selectAllFilteredCategories,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectAllFilteredCategories = $event)),
                          indeterminate: _ctx.isFilteredCategoriesIndeterminate,
                          disabled: _ctx.filteredCategories.length === 0
                        }, {
                          default: _withId(() => [
                            _createTextVNode(" Select all (" + _toDisplayString(_ctx.filteredCategories.length) + ") ", 1)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "indeterminate", "disabled"]),
                        _createVNode("span", _hoisted_20, _toDisplayString(_ctx.assignedCategories.length) + " selected ", 1)
                      ]),
                      _createVNode("div", _hoisted_21, [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: _ctx.assignedCategories,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.assignedCategories = $event))
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredCategories, (item) => {
                              return (_openBlock(), _createBlock(_component_el_checkbox, {
                                key: item.value,
                                class: "product-multi-select__item",
                                label: item.value
                              }, {
                                default: _withId(() => [
                                  _createTextVNode(_toDisplayString(item.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["label"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (_ctx.filteredCategories.length === 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_22, _toDisplayString(_ctx.$t('message.NO_DATA_FOUND')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode("button", _hoisted_24, _toDisplayString(_ctx.$t('message.CANCEL')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn btn-custom",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submitHandlerForm()))
              }, [
                _createVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('message.SUBMIT')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ])
  ]))
})